import http, {reqDefaultConfig} from "./http";
import {useRequest} from "ahooks";

let apiPath = {
  getAddressByPassId: '/sys/UdianSysUserAddressInfo/getAddressByPassId',
  saveAddressInfo: '/sys/UdianSysUserAddressInfo/saveAddressInfo',
  delAddressInfo: '/sys/UdianSysUserAddressInfo/delAddressInfo',
  setDefaultAddress: '/sys/UdianSysUserAddressInfo/setDefaultAddress',
};

/**
 * 获取用户收货地址列表
 * @param query
 * @returns {{result: ({}|*), getList: (...params: any[]) => Promise<unknown>, loading: boolean, error: Error}}
 */
export const useGetAddressByPassId = (query = {}) => {
  const { data, runAsync, error, loading } = useRequest(() => {
    return http({
      url: apiPath.getAddressByPassId,
      method: 'get',
      data: query
    });
  }, {
    manual: true,
    ...reqDefaultConfig
  });
  
  const dataParse = (data) => {
    if (!data) return {};
    data.data = data.data.map(item => {
      item.isDefault = Number(item.isDefault);
      return item;
    })
      // .sort((a, b) => b.isDefault - a.isDefault);
    //
    return data;
  };
  
  return {
    result: dataParse(data),
    loading,
    error,
    getList: runAsync
  };
};

/**
 * 新增｜编辑收货地址
 * @param query
 * @returns {{result: unknown, submit: (...params: any[]) => Promise<unknown>, loading: boolean, error: Error}}
 */
export const useSaveAddressInfo = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.saveAddressInfo,
      method: 'post',
      data: q || {}
    });
  }, {
    manual: true,
    ...reqDefaultConfig
  });
  
  return {
    result: data,
    loading,
    error,
    submit: runAsync
  };
};

/**
 * 删除收货地址
 * @param query
 * @returns {{result: unknown, submit: (...params: any[]) => Promise<unknown>, loading: boolean, error: Error}}
 */
export const useDelAddressInfo = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.delAddressInfo,
      method: 'post',
      data: q || {}
    });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    remove: runAsync
  };
};

export const useSetDefaultAddress = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.setDefaultAddress,
      method: 'post',
      data: q || {}
    });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    setDefault: runAsync
  };
};
